import React, { useEffect } from "react";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import Benefits from "../components/Benefits";
import About from "../components/About";
import LeadForm from "../components/LeadForm";
import WhatsAppFAB from "../components/WhatsAppFAB";

export default function Landing() {
  useEffect(() => {
    document.title = "Masterclass Ventas Virales — Judit Català";
  }, []);

  return (
    <div>
      <Nav />
      <Hero />
      <Benefits />
      <About />
      <LeadForm />
      <WhatsAppFAB />
      <footer className="footer">
        <div>
          © {new Date().getFullYear()} Judit Català · Todos los derechos reservados
          · <a href="#">Aviso legal</a> · <a href="#">Privacidad</a>
        </div>
      </footer>
    </div>
  );
}
